/**
 * Tetrish - Game Constants
 * Single source of truth for all tunable values.
 */

// ---------------------------------------------------------------------------
// Board dimensions
// ---------------------------------------------------------------------------
export const BOARD_COLS = 10;
export const BOARD_ROWS = 20;

// ---------------------------------------------------------------------------
// Game speed
// ---------------------------------------------------------------------------
/** Starting gravity interval in ms (level 1). */
export const INITIAL_DROP_INTERVAL = 1000;
/** Fastest possible gravity interval in ms (reached at level ~10). */
export const MIN_DROP_INTERVAL = 100;
/** Ms subtracted from the drop interval per level gained. */
export const DROP_INTERVAL_DECREMENT = 100;

// ---------------------------------------------------------------------------
// Lock delay
// ---------------------------------------------------------------------------
/** Ms a piece must rest on the ground before it locks. */
export const LOCK_DELAY = 500;
/** Max times a player move/rotate can restart the lock timer per piece. */
export const MAX_LOCK_RESETS = 15;

// ---------------------------------------------------------------------------
// Scoring (Tetris guideline values)
// ---------------------------------------------------------------------------
export const LINES_PER_LEVEL = 10;
export const BACK_TO_BACK_MULTIPLIER = 1.5;
export const ALL_CLEAR_BONUS_BASE = 800;

/** Base points for 1–4 simultaneous line clears. */
export const LINE_POINTS = { 1: 100, 2: 300, 3: 500, 4: 800 };
/** Base points for T-spin + 0–3 line clears. */
export const TSPIN_POINTS = { 0: 400, 1: 800, 2: 1200, 3: 1600 };
/** Base points for mini T-spin + 0–1 line clears. */
export const TSPIN_MINI_POINTS = { 0: 100, 1: 200 };

// ---------------------------------------------------------------------------
// Animation durations (must match CSS)
// ---------------------------------------------------------------------------
/** Duration of the line-clear row flash animation in ms. */
export const LINE_CLEAR_ANIM_MS = 300;
/** Duration of the score counter bump animation in ms. */
export const SCORE_UPDATE_ANIM_MS = 500;
/** Duration of the level-up highlight animation in ms. */
export const LEVEL_UP_ANIM_MS = 1000;
